import { Room } from "@domain";
import { SyncInteractor } from "@kernel/frontend-react-app";

export interface RestartLocalTrackInteractorProps {
  room: Room;
  type: "audio" | "video";
}

export class RestartLocalTrackInteractor extends SyncInteractor<
  RestartLocalTrackInteractorProps,
  void
> {
  public execute(props: RestartLocalTrackInteractorProps): void {
    const stream = props.room.localParticipant?.stream || null;
    if (!stream) return;
    stream.restart(props.type);
  }

  public static create(): RestartLocalTrackInteractor {
    return new RestartLocalTrackInteractor();
  }
}
